// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__X02md","box":"Loader_box__wORI1","text":"Loader_text__xMshV","loader":"Loader_loader__+lRPl","load8":"Loader_load8__qoIOy"};